<template>
  <div class="lx-box" :style="{width:screenWidth + 'px'}">
    <!-- 
      注意: 这里的 :show 绑定和事件监听保持不变。
      我们将在JS逻辑中处理延迟关闭的问题。
    -->
    <popup
      :show="showPopup"
      :x="popupPosition.x"
      :y="popupPosition.y"
      @mouseenter="handlePopupMouseEnter"
      @mouseleave="handlePopupMouseLeave"
	  @giveGif="handleGiveGif"
    />

    <div class="lx-box-list" @mouseleave="handleListMouseLeave">
      <div
        :class="index === listIndex ? 'lx-box-list-item' : 'lx-box-list-item1'"
        v-for="(item, index) in list"
        :key="index"
        @mouseenter="handleChoose(index, $event)"
      >
        <img
          ref="giftImages"
          class="lx-box-list-item-img"
          :src="item.imgUrl"
          alt=""
        />
        <div v-if="index != listIndex" class="lx-box-list-item-span">{{ item.giftName }}</div>
        <span class="lx-box-list-item-span1">{{ item.price }}US{{$t('all.bi')}}</span>
        <div
          class="lx-box-list-item-zs"
          v-if="index == listIndex"
          @click="giveGift"
        >{{$t('all.zengsong')}}</div>
      </div>
    </div>

    <div class="lx-box-gengduo" @click="handleShowGdlw">
      <img class="lx-box-gengduo-img" src="../../assets/image/zhibojian_liwu@2x.png" alt="" />
      <div class="lx-box-gengduo-div">
        <span>{{$t('all.gengduo')}}</span>
        <img src="../../assets/image/gengduo_10@2x.png" alt="" />
      </div>
    </div>
    <div class="lx-box-xian"></div>
    <div class="lx-box-jinbi">
      <img src="../../assets/image/xunibi_32@2x.png" alt="" />
      <span>{{ virtualBalance }}</span>
    </div>
  </div>
</template>

<script>
import { getGiftList, giveGift,checkIsLogin } from "@/api/zhibo";
import { getPresentUserInfo } from '@/api/user';
import popup from "../popup/popup.vue";

export default {
  name: 'liwu',
  components: {
    popup
  },
  data() {
    return {
      list: [],
      listIndex: null,
      giftList: [],
      screenWidth: window.innerWidth - 535,
      virtualBalance: 0,
      showPopup: false,
      popupPosition: {
        x: 0,
        y: 0
      },
      // 用于存储 setTimeout 的 ID，以便后续可以取消它
      hidePopupTimeoutId: null, 
    };
  },
  mounted() {
    this.getGiftList();
	this.checkIsLogin()
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    // 组件销毁前，确保清除所有未执行的定时器
    if (this.hidePopupTimeoutId) {
      clearTimeout(this.hidePopupTimeoutId);
    }
  },
  methods: {
	//礼物列表
    async getGiftList() {
      const res = await getGiftList({ liveId: this.$route.query.liveId });
      this.giftList = res.data;
      this.list = res.data.flatMap(v => v.giftList);
    },
	//判断是否登录
	async checkIsLogin(){
		const res = await checkIsLogin()
		if(res.data == 1){
			this.getPresentUserInfo();
		}
	},
	//用户信息
    async getPresentUserInfo() {
      const res = await getPresentUserInfo();
      this.virtualBalance = res.data.virtualBalance;
	  console.log('更新了吗',this.virtualBalance,res.data.virtualBalance)
    },
	//显示更多礼物
	handleShowGdlw(){
		this.$emit('show_gdlw')
	},
    handleChoose(index, event) {
      // 如果已经选中，则不做任何事
      if (this.listIndex === index) {
        return;
      }
      this.listIndex = index;
      this.showGiftPopup(event);
    },
	//赠送礼物
    async giveGift() {
      const params = {
        liveId: this.$route.query.liveId,
        giftId: this.list[this.listIndex].giftId,
        num: 1
      };
      const res = await giveGift(params);
      // 赠送成功后立即隐藏弹窗，不需要延迟
      this.hidePopupImmediately();
	  this.getPresentUserInfo()
    },
	//选择礼物多个数量赠送
	async handleGiveGif(data){
		const params = {
		  liveId: this.$route.query.liveId,
		  giftId: this.list[this.listIndex].giftId,
		  num: data
		};
		const res = await giveGift(params);
		// 赠送成功后立即隐藏弹窗，不需要延迟
		this.hidePopupImmediately();
		this.getPresentUserInfo()
	},
    showGiftPopup(event) {
      // 如果之前有隐藏的定时器，先取消它
      if (this.hidePopupTimeoutId) {
        clearTimeout(this.hidePopupTimeoutId);
        this.hidePopupTimeoutId = null;
      }

      const targetImage = this.$refs.giftImages[this.listIndex];
      if (!targetImage) return;

      const rect = targetImage.getBoundingClientRect();

      // --- 核心修改：增加边界检测 ---
      
      // 1. 定义弹窗的固定宽度 (与 Popup.vue 中的 width 保持一致)
      const POPUP_WIDTH = 352; 
      
      // 2. 计算弹窗的初始中心点 X 坐标
      let popupX = rect.left + rect.width / 2;
      const popupY = rect.top - 5; // 向上移动5px，避免与图片产生视觉间隙

      // 3. 计算弹窗的左右边缘位置
      const popupLeftEdge = popupX - POPUP_WIDTH / 2;
      const popupRightEdge = popupX + POPUP_WIDTH / 2;

      // 4. 进行边界检测和调整
      // 如果左边缘超出屏幕，则将弹窗左对齐
      if (popupLeftEdge < 0) {
        popupX = POPUP_WIDTH / 2;
      } 
      // 如果右边缘超出屏幕，则将弹窗右对齐
      else if (popupRightEdge > window.innerWidth) {
        popupX = window.innerWidth - POPUP_WIDTH / 2;
      }
      
      // --- 修改结束 ---

      this.popupPosition = { x: popupX, y: popupY };
      this.showPopup = true;
    },
    // 当鼠标离开礼物列表时触发
    handleListMouseLeave() {
      // 设置一个100毫秒的延迟来关闭弹窗
      this.hidePopupTimeoutId = setTimeout(() => {
        this.hidePopupImmediately();
        this.hidePopupTimeoutId = null; // 清除ID
      }, 100); // 100ms 的延迟通常足够应对快速移动
    },
    // 当鼠标进入弹窗时触发
    handlePopupMouseEnter() {
      // 如果存在待执行的隐藏定时器，则取消它
      if (this.hidePopupTimeoutId) {
        clearTimeout(this.hidePopupTimeoutId);
        this.hidePopupTimeoutId = null;
      }
    },
    // 当鼠标离开弹窗时触发
    handlePopupMouseLeave() {
      // 鼠标离开弹窗，立即关闭
      this.hidePopupImmediately();
    },
    // 立即隐藏弹窗的方法
    hidePopupImmediately() {
      this.showPopup = false;
      this.listIndex = null;
    },
    handleResize() {
      this.screenWidth = window.innerWidth - 535;
      if (this.showPopup && this.listIndex !== null) {
        // 重新计算位置，这里的 event 可以不传，因为 showGiftPopup 内部有备用方案
        this.showGiftPopup(); 
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "./liwu.css";
</style>


// WEBPACK FOOTER //
// liwu.vue?42f2003a